import { supabase } from '../../lib/supabaseClient';

export type DashboardCounts = {
  albums: number;
  pendingFanPosts: number;
  photoAlbums: number;
  videos: number;
  socialLinks: number;
  merchItems: number;
};

export async function getDashboardCounts(): Promise<DashboardCounts> {
  const [albumsRes, pendingRes, photoAlbumsRes, videosRes, socialRes, merchRes] = await Promise.all([
    supabase.from('albums').select('id', { count: 'exact', head: true }),
    supabase.from('fan_posts').select('id', { count: 'exact', head: true }).eq('status', 'pending'),
    supabase.from('photo_albums').select('id', { count: 'exact', head: true }),
    supabase.from('videos').select('id', { count: 'exact', head: true }),
    supabase.from('social_links').select('id', { count: 'exact', head: true }),
    supabase.from('merch_items').select('id', { count: 'exact', head: true }),
  ]);
  return {
    albums: albumsRes.count ?? 0,
    pendingFanPosts: pendingRes.count ?? 0,
    photoAlbums: photoAlbumsRes.count ?? 0,
    videos: videosRes.count ?? 0,
    socialLinks: socialRes.count ?? 0,
    merchItems: merchRes.count ?? 0,
  };
}
